<header class="header">
  <svg class="header__logo"
       viewBox="0 0 111 39.96">
    <use xlink:href="#ab-logo"></use>
  </svg>
</header>

<div class="content">
  <form [formGroup]="acceptInviteForm"
        class="form form--setup"
        id="accountSetupForm"
        (ngSubmit)="onSubmit()"
        novalidate>
    <h2 class="h2">Account Setup</h2>

    <app-error-notification [errors]="errorMessages"></app-error-notification>
    <div class="flex flexJustify--between vert-0125">
      <mat-form-field [hideRequiredMarker]="true"
                      class="ongray col__ col__sm--50e">
        <mat-label>First Name</mat-label>
        <input matInput
               type="text"
               name="firstName"
               data-test-id="firstNameInput"
               formControlName="firstName">
        <app-input-error [formControlItem]="acceptInviteForm.controls.firstName"></app-input-error>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true"
                      class="ongray col__ col__sm--50e">
        <mat-label>Last Name</mat-label>
        <input matInput
               type="text"
               name="lastName"
               data-test-id="lastName"
               formControlName="lastName">
        <app-input-error [formControlItem]="acceptInviteForm.controls.lastName"></app-input-error>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true"
                      class="ongray col__ col__sm--50e">
        <mat-label>Email Address</mat-label>
        <input matInput
               type="email"
               id="email"
               name="email"
               formControlName="email"
               autocomplete="off">
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true"
                      class="ongray col__ col__sm--50e">
        <mat-label class="test">Phone Number</mat-label>
        <app-mat-phone-input matInput
                             id="phoneNumber"
                             name="phoneNumber"
                             formControlName="phoneNumber"></app-mat-phone-input>
        <app-input-error [formControlItem]="acceptInviteForm.controls.phoneNumber"></app-input-error>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true"
                      class="ongray col__ col__sm--50e">
        <mat-label>Password</mat-label>
        <input matInput
               id="password"
               name="password"
               required
               minlength="8"
               [type]="pwShown ? 'text' : 'password'"
               formControlName="password" />
        <span matSuffix
              mat-icon-button
              aria-label="Show"
              [ngStyle]="{'color': pwShown ? '#006EC5' : '#C3C9D9'}"
              (click)="pwShown = !pwShown">
          <mat-icon fontSet="far"
                    fontIcon="fa-eye"></mat-icon>
        </span>
        <app-input-error [formControlItem]="acceptInviteForm.controls.password"></app-input-error>
      </mat-form-field>

      <mat-form-field [hideRequiredMarker]="true"
                      class="ongray col__ col__sm--50e">
        <mat-label>Confirm Password</mat-label>
        <input matInput
               id="passwordConfirmation"
               name="passwordConfirmation"
               required
               minlength="8"
               [type]="pwShown ? 'text' : 'password'"
               formControlName="passwordConfirmation" />
        <span matSuffix
              mat-icon-button
              aria-label="Show"
              [ngStyle]="{'color': pwShown ? '#006EC5' : '#C3C9D9'}"
              (click)="pwShown = !pwShown">
          <mat-icon fontSet="far"
                    fontIcon="fa-eye"></mat-icon>
        </span>
        <app-input-error [formControlItem]="acceptInviteForm.controls.passwordConfirmation"></app-input-error>
      </mat-form-field>
    </div>

    <mat-checkbox class="col__ mat-checkbox--wrap vert-0025"
                  name="tc"
                  id="tc"
                  disableRipple
                  formControlName="acceptedTOS">I have read and agree to Action Builder's <span
            (click)="onShowTermsClick()"
            class="link">terms and conditions.</span></mat-checkbox>

    <button class="btn vert-0125"
            type="submit"
            [disabled]="acceptInviteForm.pristine || acceptInviteForm.invalid || isSubmitting">Create Account</button>

  </form>
</div>
